<template>
  <div 
    class="sp-item"
    v-if="!(cfg_view_staked && num_staked == 0)"
    >
    <div class="ui-card bg-trans">

      <div class="bg-card py-4 tac">
        <div>

          <span class="ui-icon size-40" style="position: relative;z-index: 1;">
            <img :src="(`/static/token_icons/${item.item_icon}?v2`) ">
          </span>

          <span v-if="item.item_icon_2" class="ui-icon size-40" style="margin-left: -10px;">
            <img :src="(`/static/token_icons/${item.item_icon_2}?v2`) ">
          </span>
        </div>

        <div class="d-flex align-items-center flex-column justify-content-center" style="min-height: 75px;">

          <div class="i d-flex justify-content-center align-items-center" style="min-height: 50px; line-height: 25px;">
            <span>
              {{lg('',{
                en: `${item.token_symbol} Pool`,
                zh: `抵押 ${item.token_symbol}，得到 ${item.token_earn_symbol}`,
              })}}
            </span>
          </div>

          <div v-if="item.second_title" class="text-center b" style="min-height: 25px; line-height: 25px;">
            <span style="font-size: 1.1em; ">
              {{lg('',item.second_title)}}
            </span>
          </div>
        </div>

      </div>

      <div class="bg-white">

        <div class="py-3 tac ">
          <h1 class="b mb-0">
            {{num_reward | tofixed2 | qfw}}
          </h1>
          <div class="t-gray" style="line-height: 20px;">
            {{item.token_earn_symbol}}
            <br class="mb-none">
            Earned
          </div>
        </div>

        <div class="mx-4">
          <span 
            v-if="card_cfg && card_cfg.status_inactive"
            class="btn btn-lg btn-primary w-100 op8"
            style="filter: grayscale(1);"
            >
            {{lg('',{
              en: 'Closed',
              zh: '已关闭',
            })}}
          </span>
          <router-link 
            v-else
            class="btn btn-lg btn-primary w-100"
            :to="{
              name: 'stake_item_farm',
              params: {
                id: item.id,
              },
            }"
            >
            {{lg('',{
              en: 'Open',
              zh: '打开',
            })}}
          </router-link>
        </div>

        <div class="px-4 pb-3">
          <div class="d-flex small mt-4">
            <span class="b">
              APY:
            </span>
            <span class="ml-auto"> 
              {{calc_apy | bfh}}
            </span>
          </div>

          <div class="d-flex small">
            <span class="b">
              {{lg('',{
                en: 'Your Stake',
                zh: '质押数量',
              })}}:
            </span>
            <span class="ml-auto"> 
              {{num_staked | tofixed2 | qfw}}
              {{item.token_symbol}}
            </span>
          </div>

          <div class="d-flex small">
            <span class="b">
              {{lg('',{
                en: 'TVL',
                zh: '总锁定',
              })}}:
            </span>
            <span class="ml-auto"> 
              {{num_staked_total_on_usd | tofixed2 | qfw}}
              USD
              <!-- {{num_staked_total | tofixed2 | qfw}}
              {{item.token_symbol}} -->
            </span>
          </div>
        </div>
      </div>
      

      <div class="card-bg-gray py-3 px-4 small">
        <div class="mb-2" style="line-height: 20px;">
          <span>
            {{lg('',{
              en: 'Start Time',
              zh: '质押时间',
            })}}:
          </span>
          <br>
          <span class="ml-auto">
            {{lg('',item.start_time)}}
          </span>
        </div>
        <div class="mb-2" style="line-height: 20px;">
          <span>
            {{lg('',{
              en: 'Earn Per Day',
              zh: '每日奖励总量',
            })}}:
          </span>
          <br>
          <span class="ml-auto">
            {{item.des_earn_per_day | qfw}} 
            {{item.token_earn_symbol}}
          </span>
        </div>
        <div class="tac">

          <span class="ml-auto">
            <a 
              :href="`${$store.state.sitecfg.url_network_address_view}${item.reward_address}`"
              class="tac u"
              target="_blank"
              >
              {{lg('',{
                en: 'View on HecoScan',
                zh: '在HecoScan查看',
              })}}
            </a>
          </span>
        </div>
        
      </div>


    </div>
    
  </div>
</template>

<script>
import bus from '@/bus.js'
import {mapActions} from 'vuex'

export default {
  name: 'farmCard',
  components: {},
  props: [
    'item',
    'card_cfg',
    'cfg_view_staked',
  ],
  data() {
    return {
      num_staked: '-',
      num_reward: '-',

      // 
      num_staked_total: '-',
      num_staked_total_on_usd: '-',

      // 

      // LAVA-REC apy
      LAVARECLPTotalValue: '',
      GenePrice: '',

      // TPT2 LAVA3 apy
      res_getFormPrice: '',

      res_getFOMPTPTTotalValue: '',
      res_getFOMPUSDTTotalValue: '',
      res_getFOMAUSDTTotalValue: '',

      res_getFilDAUSDTTotalValue: '',
      res_getFilDALAVLPTotalValue: '',

      res_getVIBKNULSTotalValue: '',
      res_getVIBKLAVATotalValue: '',
      res_getVIBKPrice: '',

      res_getDATTPrice: '',
      res_getDATTNULSTotalValue: '',
      res_getDATTUSDTTotalValue: '',

      res_getSATOUSDTTotalValue: '',

      res_getARCHUSDTTotalValue: '',
    }
  },
  computed: {
    calc_apy(){
      let v = this
      let mark = '-'
      let a,b
      if(v.num_staked_total != '-' && bus.lava_price){
        if(v.item.id == 'GENE'){
          // a = v.num_staked_total
          // b = v.item.des_earn_per_day * 365
          // mark = b/a
          let p = bus.lava_price;
          a = v.num_staked_total * p
          b = v.GenePrice
          mark = b/a
        }
        else if(v.item.id == 'LAVA-REC'){
          a = v.LAVARECLPTotalValue
          b = v.GenePrice
          mark = b/a
        }
        else if(v.item.id == 'TPT2' || v.item.id == 'LAVA3'){
          a = v.num_staked_total * v.item.price_on_usd;
          b = v.item.des_earn_per_day * v.res_getFormPrice * 365
          mark = b/a
        }
        else if(v.item.id == 'FOMP-TPT'){
          a = v.res_getFOMPTPTTotalValue;
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'FOMP-USDT'){
          a = v.res_getFOMPUSDTTotalValue;
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'FOMA-USDT'){
          a = v.res_getFOMAUSDTTotalValue;
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'LAVA4' || v.item.id == 'LAVA5' || v.item.id == 'LAVA6'){
          a = v.num_staked_total * bus.lava_price;
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'ITF'){
          a = v.num_staked_total * v.item.price_on_usd;
          b = v.item.des_earn_per_day * bus.lava_price * 365
          mark = b/a
        }
        else if(v.item.id == 'ITF-LAVA'){
          a = v.num_staked_total;
          b = v.item.des_earn_per_day * 365;
          mark = b/a
        }
        else if(v.item.id == 'ITF-ETH'){
          a = v.num_staked_total * 114;
          b = v.item.des_earn_per_day * 365;
          mark = b/a
        }
        else if(v.item.id == 'HOO'){
          a = v.num_staked_total * v.item.price_on_usd;
          b = v.item.des_earn_per_day * bus.lava_price * 365
          mark = b/a
        }
        else if(v.item.id == 'FilDA-USDT-FilDA-LAVA'){
          a = v.res_getFilDAUSDTTotalValue;
          b = v.res_getFilDALAVLPTotalValue * 365
          mark = 0
        }
        else if(v.item.id == 'SATO1'){
          a = v.num_staked_total * bus.lava_price
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'SATO2'){
          a = v.num_staked_total
          b = v.item.des_earn_per_day * 365
          mark = b/a
        }
        else if(v.item.id == 'VIBK-NULS'){
          a = v.res_getVIBKNULSTotalValue
          b = v.item.des_earn_per_day * v.res_getVIBKPrice * 365
          mark = b/a
        }
        else if(v.item.id == 'VIBK-LAVA'){
          a = v.res_getVIBKLAVATotalValue
          b = v.item.des_earn_per_day * v.res_getVIBKPrice * 365
          mark = b/a
        }
        else if(v.item.id == 'LAVA8'){
          a = v.num_staked_total * bus.lava_price
          b = v.item.des_earn_per_day * v.res_getDATTPrice * 365
          // b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'DATT-NULS'){
          a = v.res_getDATTNULSTotalValue
          b = v.item.des_earn_per_day * v.res_getDATTPrice * 365
          mark = b/a
        }
        else if(v.item.id == 'DATT-USDT'){
          a = v.res_getDATTUSDTTotalValue
          b = v.item.des_earn_per_day * v.res_getDATTPrice * 365
          mark = b/a
        }
        else if(v.item.id == 'SATO-USDT'){
          a = v.res_getSATOUSDTTotalValue
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'LAVA9'){
          a = v.num_staked_total * bus.lava_price
          // b = v.item.des_earn_per_day * v.res_getDATTPrice * 365
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else if(v.item.id == 'ARCH-USDT'){
          a = v.res_getARCHUSDTTotalValue
          b = v.item.des_earn_per_day * v.item.price_on_usd * 365
          mark = b/a
        }
        else{
          console.log(v.item.id);
          let p = v.item.price_on_usd;
          if(v.item.id == 'LAVA' || v.item.id == 'LAVA2' || v.item.id == 'LAVA7'){
            p = bus.lava_price;
          }
          // a = v.num_staked_total * v.item.price_on_usd
          a = v.num_staked_total * p
          b = v.item.des_earn_per_day * bus.lava_price * 365
          mark = b/a
        }
        
        // usdt 计价的总锁定量赋值给组件 以便调用
        v.num_staked_total_on_usd = a
      }
      return mark
    },
  },
  watch: {},
  methods: {
    ...mapActions([
      'getStakeTokenStaked',
      'getStakeRewardAvaiable',
      'getTotalStake',
      'getLAVARECLPTotalValue',
      'getGenePrice',
      'getFormPrice',
      'getFOMPTPTTotalValue',
      'getFOMPUSDTTotalValue',
      'getFOMAUSDTTotalValue',
      'getFilDAUSDTTotalValue',
      'getFilDALAVLPTotalValue',
      'getVIBKNULSTotalValue',
      'getVIBKPrice',
      'getVIBKLAVATotalValue',
      'getDATTPrice',
      'getDATTNULSTotalValue',
      'getDATTUSDTTotalValue',
      'getSATOUSDTTotalValue',
      'getARCHUSDTTotalValue',
    ]),

    async getStaked(){
      let v = this
      // 
      let address_my = v.$store.state.web3.account
      let mark =  await v.getStakeTokenStaked({
        stakeTokenAddress:v.item.token_address,
        stakeRewardAddress: v.item.reward_address,
        address: address_my,
      })
      v.num_staked = mark
    },

    async getStakedTotal(){
      let v = this
      // 
      // let address_my = v.$store.state.web3.account
      let mark =  await v.getTotalStake({
        id: v.item.id,
        stakeTokenAddress:v.item.token_address,
        stakeRewardAddress: v.item.reward_address,
        // address: address_my,
      })
      v.num_staked_total = mark
    },

    async getReward(){
      let v = this
      let address_my = v.$store.state.web3.account
      let mark =  await v.getStakeRewardAvaiable({
        stakeRewardAddress: v.item.reward_address,
        address: address_my,
      })
      // console.log('*********************')
      // console.log(mark)
      v.num_reward = mark
    },

    async getLavaRecApyParams(){
      let v = this
      
      v.LAVARECLPTotalValue = await v.getLAVARECLPTotalValue()
      let temp_price = await v.getGenePrice()

      v.GenePrice = v.item.des_earn_per_day * temp_price * 365
    },

    async call_getFormPrice(){
      let v = this
      console.log('==call_getFormPrice')
      v.res_getFormPrice = await v.getFormPrice()
      console.log('== res call_getFormPrice res:',v.res_getFormPrice)
    },

    async call_sp_token_web3_fn(){
      let v = this

      if(v.item.id == 'LAVA-REC' || v.item.id == 'GENE'){
        this.getLavaRecApyParams()
      }

      if(v.item.id == 'TPT2' || v.item.id == 'LAVA3'){
        this.call_getFormPrice()
      }

      else if(v.item.id == 'FOMP-TPT'){
        v.res_getFOMPTPTTotalValue  = await v.getFOMPTPTTotalValue();
      }
      else if(v.item.id == 'FOMP-USDT'){
        v.res_getFOMPUSDTTotalValue  = await v.getFOMPUSDTTotalValue();
      }
      else if(v.item.id == 'FOMA-USDT'){
        v.res_getFOMAUSDTTotalValue  = await v.getFOMAUSDTTotalValue();
      }
      else if(v.item.id == 'FilDA-USDT-FilDA-LAVA'){
        v.res_getFilDAUSDTTotalValue = await v.getFilDAUSDTTotalValue()
        v.res_getFilDALAVLPTotalValue = await v.getFilDALAVLPTotalValue()
      }

      else if(v.item.id == 'VIBK-NULS'){
        v.res_getVIBKNULSTotalValue = await v.getVIBKNULSTotalValue()
        v.res_getVIBKPrice = await v.getVIBKPrice()
      }
      else if(v.item.id == 'VIBK-LAVA'){
        v.res_getVIBKLAVATotalValue = await v.getVIBKLAVATotalValue()
        v.res_getVIBKPrice = await v.getVIBKPrice()
      }

      else if(v.item.id == 'LAVA8'){
        v.res_getDATTPrice = await v.getDATTPrice()
      }
      else if(v.item.id == 'DATT-NULS'){
        v.res_getDATTNULSTotalValue = await v.getDATTNULSTotalValue()
        v.res_getDATTPrice = await v.getDATTPrice()
      }
      else if(v.item.id == 'DATT-USDT'){
        v.res_getDATTUSDTTotalValue = await v.getDATTUSDTTotalValue()
        v.res_getDATTPrice = await v.getDATTPrice()
      }
      else if(v.item.id == 'SATO-USDT'){
        v.res_getSATOUSDTTotalValue = await v.getSATOUSDTTotalValue()
      }
      else if(v.item.id == 'ARCH-USDT'){
        v.res_getARCHUSDTTotalValue = await v.getARCHUSDTTotalValue()
      }
    },

    run(){
      
      this.getStakedTotal()
      this.getStaked()
      this.getReward()
      
      this.call_sp_token_web3_fn()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .sp-item{
    width: 90%;
    margin: 0 auto;

    .sp-core{
      display: inline-block;
      border: 1px solid $c;
      color: $c;
      border-radius: 4px;
      padding: 0 5px;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      height: 22px;
    }
  }
</style>